import React from "react";
import { connect } from "react-redux";
import SmartComponent from "../SmartComponent";
import { updateFrameList } from "../../actions/panel";

class FrameListButton extends SmartComponent {
  render() {
    const label = window
      .moment(this.props.frameList.startValidity)
      .format("DD HHmm");

    const attrs = {
      id: `frame-list-selector_${this.props.panelId}_${this.props.frameList.id}`,
      onClick: this.props.updateFrameList,
      className: "frame-list-selector selector btn"
    };

    if (this.props.isNow) {
      attrs.className += " btn-success";
      if (this.props.isSelected) {
        attrs.className += " selected active";
      }
    } else if (this.props.isSelected) {
      attrs.className += " selected active";
    } else {
      attrs.className += " btn-default";
    }

    return <div {...attrs}>{label}</div>;
  }
}

const mapDispatchToProps = {
  updateFrameList
};

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...ownProps,
  ...stateProps,
  updateFrameList: dispatchProps.updateFrameList.bind(
    undefined,
    ownProps.panelId,
    ownProps.frameList.id
  )
});

export default connect(null, mapDispatchToProps, mergeProps)(FrameListButton);
